var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 52,
    rx: 5,
    fill: "url(#paint0_radial_3111_30405)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9811 28.1999C35.8307 29.5327 35.165 30.7638 34.1145 31.6516C33.064 32.5395 31.7046 33.0202 30.3026 32.9994H26.5693C25.9453 32.9994 25.3468 32.7623 24.9055 32.3404C24.4643 31.9185 24.2164 31.3463 24.2164 30.7496V27.7499L22.334 29.0998L21.3928 27.8999L24.5301 25.6501C24.6658 25.5528 24.831 25.5001 25.0007 25.5001C25.1704 25.5001 25.3355 25.5528 25.4713 25.6501L28.6085 27.8999L27.6673 29.0998L25.785 27.7499V30.7496C25.785 30.9485 25.8676 31.1392 26.0147 31.2799C26.1618 31.4205 26.3613 31.4995 26.5693 31.4995H30.3026C31.3104 31.5227 32.2909 31.1847 33.0513 30.5519C33.8118 29.9192 34.2973 29.0374 34.4125 28.0799C34.492 27.203 34.2465 26.3274 33.7188 25.6062C33.1911 24.885 32.415 24.3643 31.5262 24.1353C31.3985 24.1036 31.2813 24.0416 31.1853 23.9551C31.0894 23.8686 31.0178 23.7603 30.9772 23.6403C30.5646 22.4401 29.7662 21.395 28.6958 20.6541C27.6254 19.9132 26.3378 19.5143 25.0164 19.5143C23.695 19.5143 22.4073 19.9132 21.3369 20.6541C20.2666 21.395 19.4682 22.4401 19.0556 23.6403C19.015 23.7603 18.9434 23.8686 18.8474 23.9551C18.7514 24.0416 18.6342 24.1036 18.5065 24.1353C17.6119 24.3584 16.8285 24.8766 16.2947 25.5984C15.7608 26.3201 15.5109 27.199 15.5889 28.0799C15.7041 29.0374 16.1896 29.9192 16.95 30.5519C17.7105 31.1847 18.6909 31.5227 19.6987 31.4995H22.6477V32.9994H19.6987C18.2968 33.0202 16.9373 32.5395 15.8868 31.6516C14.8364 30.7638 14.1707 29.5327 14.0203 28.1999C13.9159 27.0416 14.2167 25.883 14.8753 24.9058C15.5339 23.9286 16.5132 23.1881 17.6595 22.8004C18.2295 21.3873 19.2338 20.1724 20.54 19.3155C21.8461 18.4586 23.3931 18 24.9771 18C26.5612 18 28.1081 18.4586 29.4143 19.3155C30.7205 20.1724 31.7247 21.3873 32.2948 22.8004C33.4499 23.1801 34.4395 23.9173 35.1072 24.8952C35.7748 25.8731 36.0824 27.036 35.9811 28.1999Z",
    fill: "#222222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3111_30405",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2083 12.2041) rotate(-32.6376) scale(110.191 59.2745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.9f422525442a34b0a2278ee109d22c1c.svg";
export { ForwardRef as ReactComponent };